import {
    changeFormat, dateLongFormat, dayJsFromDtti, displayCash, displayDistance,
    getHourFromSec,
    insertComma,
    meterToKilo, secsToHourMinute,
    secToHourMinute,
} from "@/components/tacho/common/CommonFunc";
import {setting} from '@/setting/index.js'
import {MeterStatusType} from "@/type";
import {getAzimuth} from "@/composables/Functional";
import PayType, {convertPayTypeToTxt, convertTransactionPayTypeToPayType, PayTypeByNames} from '@/type/PayType';
import dayjs from "dayjs";
import {toInteger} from "lodash";

export function objectToQueryString(obj, removeStart = false) {
    if (!obj) {
        return '';
    }

    const keyValL = Object.keys(obj).filter(key => obj[key] !== undefined);

    if (!keyValL.length) {
        return '';
    }

    const start = removeStart ? '' : '?';
    return `${start}${keyValL.map(key => `${key}=${obj[key]}`).join('&')}`;
}

class drivingDailyEntity {
    constructor(allPayFare, allAddFare, allCallFare, allWorkDist, allWorkTime, allCarCount, allDriverCount, allBlankDist, allHipassFare) {
        this.allPayFare = allPayFare;
        this.allAddFare = allAddFare;
        this.allFare = allPayFare + allAddFare + allCallFare + allHipassFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.allDist = allWorkDist + allBlankDist;
        this.allHipassFare = allHipassFare;
    }

    get allCarCountDisplay() {
        return `${this.allCarCount.toString()}대`;
    }

    get allDriverCountDisplay() {
        return `${this.allDriverCount.toString()}명`;
    }

    get allWorkDistDisplay() {
        return `${this.allWorkDist.toString()}Km`;
    }

    get allDistDisplay() {
        return `${this.allDist.toString()}Km`;
    }

    get allPayFareDisplay() {
        return `${insertComma(this.allPayFare).toString()}원`;
    }

    get allCallFareDisplay() {
        return `${insertComma(this.allCallFare).toString()}원`;
    }

    get allAddFareDisplay() {
        return `${insertComma(this.allAddFare).toString()}원`;
    }

    get allFareDisplay() {
        return `${insertComma(this.allFare).toString()}원`;
    }

    fromMap(v) {
        this.allCarCount = v.allCarCount;
        this.allDriverCount = v.allDriverCount;
        this.allCallFare = v.allCallFare
        this.allWorkTime = getHourFromSec(v.allWorkTime);
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allPayFare = v.allPayFare;
        this.allAddFare = v.allAddFare;
        this.allFare = v.allPayFare + v.allAddFare + v.allCallFare + v.allHipassFare;
        this.allDist = meterToKilo(v.allWorkDist + v.allBlankDist).toFixed(1);
        this.allHipassFare = v.allHipassFare;
        return this;
    }

    fields() {
        return [
            {key: "allCarCount", label: "총 차량대수"},
            {key: "allDriverCount", label: "총 기사수"},
            {key: "allWorkTime", label: "총 실차시간"},
            {key: "allWorkDist", label: "총 실차거리"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allPayFare", label: "총 결제금액"},
            {key: "allCallFare", label: "총 호출요금"},
            {key: "allAddFare", label: "총 추가금액"},
            {key: "allFare", label: "총 합계금액"},
        ]
    }
}

// ds.kang
class periodSummaryEntity {
    constructor(allPayFare, allAddFare, allCallFare, allWorkDist, allWorkTime, allCarCount, allDriverCount, allBlankDist, allHipassFare) {
        this.allPayFare = allPayFare;
        this.allAddFare = allAddFare;
        this.allFare = allPayFare + allAddFare + allCallFare + allHipassFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.allDist = allWorkDist + allBlankDist;
        this.allHipassFare = allHipassFare;
    }

    fromMap(v) {
        this.allCarCount = v.carCount;
        this.allDriverCount = v.driverCount;
        this.allCallFare = v.callFare
        this.allWorkTime = getHourFromSec(v.workTime);
        this.allWorkDist = meterToKilo(v.workDist).toFixed(1);
        this.allPayFare = v.payFare;
        this.allAddFare = v.addFare;
        this.allFare = v.fare;
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.allHipassFare = v.hipassFare;
        return this;
    }

    fields() {
        return [
            {key: "allCarCount", label: "총 차량대수"},
            {key: "allDriverCount", label: "총 기사수"},
            {key: "allWorkTime", label: "총 실차시간"},
            {key: "allWorkDist", label: "총 실차거리"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allPayFare", label: "총 결제금액"},
            {key: "allCallFare", label: "총 호출요금"},
            {key: "allAddFare", label: "총 추가금액"},
            {key: "allFare", label: "총 합계금액"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allCallFare", label: "총 호출요금"},
        ]
    }
}

class periodRecordEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, addFare, hipassFare, callFare) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.blankTime = allTime - workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.hipassFare = hipassFare;
    }


    get minDttiDisplay() {
        return changeFormat(this.minDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get maxDttiDisplay() {
        return changeFormat(this.maxDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payFareDisplay() {
        return insertComma(this.payFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get fareDisplay() {
        return insertComma(this.fare);
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.stDtti;
        this.maxDtti = v.edDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.allTime - v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        this.addFare = v.addFare;
        this.hipassFare = v.hipassFare;
        this.callFare = v.callFare;
        return this;
    }

    fields() {
        return [
            {key: "viewYn", label: ""},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
        ]
    }
}

class drivingCloseDailyEntity {
    constructor(viewYn, allPayFare, allAddFare, allCallFare, allWorkDist, allWorkTime, allCarCount, allDriverCount, allHipassFare, allBlankDist, allBlankTime, allDist, allTime, allFare) {
        this.viewYn = viewYn;
        this.allPayFare = allPayFare;
        // this.allAddFare = allAddFare + allCallFare;
        this.allAddFare = allAddFare;
        this.allFare = allFare;//allPayFare + allAddFare + allCallFare + allHipassFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.allDist = allDist;
        this.allHipassFare = allHipassFare;
        this.allBlankDist = allBlankDist;
        this.allBlankTime = allBlankTime;
        this.allTime = allTime;
    }

    fromMap(v) {
        this.viewYn = v.viewYn;
        this.allCarCount = v.allCarCount;
        this.allDriverCount = v.allDriverCount;
        this.allWorkTime = getHourFromSec(v.allWorkTime);
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allPayFare = parseInt(v.allPayFare);
        // this.allAddFare = v.allAddFare + v.allCallFare;
        this.allAddFare = v.allAddFare;
        this.allFare = v.allFare;//v.allPayFare + v.allAddFare + v.allCallFare + v.allHipassFare;
        this.allCallFare = v.allCallFare;
        this.allDist = meterToKilo(v.allDist).toFixed(1);
        this.allHipassFare = v.allHipassFare;
        this.allBlankDist = meterToKilo(v.allBlankDist).toFixed(1);
        this.allBlankTime = getHourFromSec(v.allBlankTime);
        this.allTime = getHourFromSec(v.allTime);
        return this;
    }

    fields() {
        return [
            {key: "allCarCount", label: "총 차량대수"},
            {key: "allDriverCount", label: "총 기사수"},
            {key: "allWorkTime", label: "총 실차시간"},
            {key: "allWorkDist", label: "총 실차거리"},
            {key: "allDist", label: "총 운행거리"},
            {key: "allPayFare", label: "총 결제금액"},
            {key: "allCallFare", label: "총 호출금액"},
            {key: "allAddFare", label: "총 추가금액"},
            {key: "allFare", label: "총 합계금액"},
            {key: "allDist", label: "총 운행거리"},
        ]
    }
}

class drivingMonthlyEntity {

    constructor(allPayfare, allAddFare, allCallFare, allWorkDist, allBlankDist, allWorkTime) {
        this.allPayfare = allPayfare;
        this.allAddFare = allAddFare + allCallFare;
        this.allFare = allPayfare + allAddFare + allCallFare;
        this.onDist = allWorkDist + allBlankDist;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
    }

    fromMap(v) {
        this.allPayfare = v.allPayfare;
        this.allAddFare = v.allAddFare + v.allCallFare;
        this.allFare = v.allPayfare + v.allAddFare + v.allCallFare;
        this.onDist = meterToKilo(v.allWorkDist + v.allBlankDist).toFixed(1);
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allWorkTime = secToHourMinute(v.allWorkTime).toFixed();
        return this;
    }

    fields() {
        return [
            {key: "allPayfare", label: "결제금액"},
            {key: "allAddFare", label: "추가금액"},
            {key: "allFare", label: "합계금액"},
            {key: "onDist", label: "총주행거리"},
            {key: "allWorkDist", label: "영업거리"},
            {key: "allWorkTime", label: "영업시간"},
        ]
    }
}

class tripDetailClosingDayDataEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, addFare
        , cashFare, cardFare, hipassFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.blankTime = allTime - workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.hipassFare = hipassFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    get minDttiDisplay() {
        return changeFormat(this.minDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get maxDttiDisplay() {
        return changeFormat(this.maxDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payFareDisplay() {
        return insertComma(this.payFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get cashFareDisplay() {
        return insertComma(this.cashFare);
    }
    get cardFareDisplay() {
        return insertComma(this.cardFare);
    }
    get fareDisplay() {
        return insertComma(this.fare);
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.allTime - v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        // this.addFare = v.addFare + v.callFare;
        this.addFare = v.addFare;
        this.hipassFare = v.hipassFare
        this.payType = convertPayTypeToTxt(v.payType);
        this.payDtti = v.payDtti;
        this.viewYn = v.viewYn;
        this.callFare = v.callFare;
        this.cashFare = v.cashFare;
        this.cardFare = v.cardFare;
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "cashFare", label: "현금 (원)"},
            {key: "cardFare", label: "카드금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
        ]
    }
}

class tripDetailDataEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, addFare, hipassFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.blankTime = allTime - workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.hipassFare = hipassFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.allTime - v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        // this.addFare = v.addFare + v.callFare;
        this.addFare = v.addFare;
        this.hipassFare = v.hipassFare
        this.payType = convertPayTypeToTxt(v.payType);
        this.payDtti = v.payDtti;
        this.viewYn = v.viewYn;
        this.callFare = v.callFare;
        return this;
    }

    get minDttiDisplay() {
        return changeFormat(this.minDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get maxDttiDisplay() {
        return changeFormat(this.maxDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payFareDisplay() {
        return insertComma(this.payFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get fareDisplay() {
        return insertComma(this.fare);
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
        ]
    }
}

class tripDetailClosingDayCommuteDataEntity {
    constructor(seq, viewYn, addFare, allDist, allFare, callFare, allTime, blankDist, blankTime, carNum, createDtti, driverId, edDtti
        , hipassFare, payFare, stDtti, workDist, workTime, driveKey, hour, typeStDtti, typeEdDtti, cashFare, cardFare) {
        this.seq = seq;
        this.viewYn = viewYn;
        this.carNum = carNum; // 차량번호
        this.driverId = driverId; // 사원번호
        this.stDtti = stDtti; // 시작일자
        this.edDtti = edDtti; // 종료일자
        this.workTime = workTime; // 실차시간
        this.blankTime = blankTime; // 공차시간
        this.allTime = allTime; // 운행시간
        this.workDist = workDist; // 실차거리
        this.blankDist = blankDist; // 공차거리
        this.allDist = allDist; // 운행거리
        this.allFare = allFare; // 결제요금
        this.payFare = payFare; // 미터기 결제요금
        // this.addFare = addFare + callFare; // 추가결제요금
        this.callFare = callFare;
        this.addFare = addFare; // 추가결제요금
        this.hipassFare = hipassFare; // 하이패스요금
        this.createDtti = createDtti; // 생성일시
        this.driveKey = driveKey;
        this.hour = hour;
        this.typeStDtti = typeStDtti;
        this.typeEdDtti = typeEdDtti;
        this.unRegDtti = false;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    get id() {
        return `${this.carNum}_${this.stDtti}_${this.edDtti}`
    }

    get stDttiDisplay() {
        return changeFormat(this.stDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get edDttiDisplay() {
        return changeFormat(this.edDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get createDttiDisplay() {
        return changeFormat(this.createDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payFareDisplay() {
        return insertComma(this.payFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get cashFareDisplay() {
        return insertComma(this.cashFare);
    }
    get cardFareDisplay() {
        return insertComma(this.cardFare);
    }
    get allFareDisplay() {
        return insertComma(this.allFare);
    }

    fromMap(v) {
        this.seq = v.seq;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.blankTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.allDist).toFixed(1);
        this.allFare = parseInt(v.allFare);
        this.payFare = parseInt(v.payFare);
        // this.addFare = parseInt(v.addFare) + parseInt(v.callFare);
        this.callFare = parseInt(v.callFare);
        this.addFare = parseInt(v.addFare);
        this.hipassFare = parseInt(v.hipassFare);
        this.viewYn = v.viewYn;
        this.createDtti = v.createDtti;
        this.driveKey = v.driveKey;
        this.hour = v.hour;
        if (v.stDtti === null || v.edDtti === null) {
            this.unRegDtti = true;
        }
        this.cashFare = v.cashFare;
        this.cardFare = v.cardFare;
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "stDtti", label: "출근시간"},
            {key: "edDtti", label: "퇴근시간"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "cashFare", label: "현금 (원)"},
            {key: "cardFare", label: "카드금액 (원)"},
            {key: "allFare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
            {key: "createDtti", label: "갱신시간"},
        ]
    }
}

class tripDetailCommuteDataEntity {
    constructor(seq, viewYn, addFare, allDist, allFare, callFare, allTime, blankDist, blankTime, carNum, createDtti, driverId, edDtti, hipassFare, payFare, stDtti, workDist, workTime, driveKey, hour, typeStDtti, typeEdDtti) {
        this.seq = seq;
        this.viewYn = viewYn;
        this.carNum = carNum; // 차량번호
        this.driverId = driverId; // 사원번호
        this.stDtti = stDtti; // 시작일자
        this.edDtti = edDtti; // 종료일자
        this.workTime = workTime; // 실차시간
        this.blankTime = blankTime; // 공차시간
        this.allTime = allTime; // 운행시간
        this.workDist = workDist; // 실차거리
        this.blankDist = blankDist; // 공차거리
        this.allDist = allDist; // 운행거리
        this.allFare = allFare; // 결제요금
        this.payFare = payFare; // 미터기 결제요금
        // this.addFare = addFare + callFare; // 추가결제요금
        this.callFare = callFare;
        this.addFare = addFare; // 추가결제요금
        this.hipassFare = hipassFare; // 하이패스요금
        this.createDtti = createDtti; // 생성일시
        this.driveKey = driveKey;
        this.hour = hour;
        this.typeStDtti = typeStDtti;
        this.typeEdDtti = typeEdDtti;
        this.unRegDtti = false;
    }


    get id() {
        return `${this.carNum}_${this.stDtti}_${this.edDtti}`
    }

    get stDttiDisplay() {
        return changeFormat(this.stDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get edDttiDisplay() {
        return changeFormat(this.edDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get createDttiDisplay() {
        return changeFormat(this.createDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payFareDisplay() {
        return insertComma(this.payFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get allFareDisplay() {
        return insertComma(this.allFare);
    }

    fromMap(v) {
        this.seq = v.seq;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.blankTime = secToHourMinute(v.blankTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.allDist).toFixed(1);
        this.allFare = parseInt(v.allFare);
        this.payFare = parseInt(v.payFare);
        // this.addFare = parseInt(v.addFare) + parseInt(v.callFare);
        this.callFare = parseInt(v.callFare);
        this.addFare = parseInt(v.addFare);
        this.hipassFare = parseInt(v.hipassFare);
        this.viewYn = v.viewYn;
        this.createDtti = v.createDtti;
        this.driveKey = v.driveKey;
        this.hour = v.hour;
        if (v.stDtti === null || v.edDtti === null) {
            this.unRegDtti = true;
        }
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "stDtti", label: "출근시간"},
            {key: "edDtti", label: "퇴근시간"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "allFare", label: "합계금액 (원)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "blankDist", label: "주행거리 (KM)"},
            {key: "allDist", label: "총 운행거리 (KM)"},
            {key: "workTime", label: "영업시간"},
            {key: "blankTime", label: "주행시간"},
            {key: "allTime", label: "근무시간"},
            {key: "createDtti", label: "갱신시간"},
        ]
    }
}

// 개인택시 운행데이터 조회
class privateDrivingDataEntity {
    constructor(infoDtti, officeId, carNum, driverId, speed, dist, carX, carY, viewYn, apiDtti) {
        this.infoDtti = infoDtti,
            this.officeId = officeId,
            this.carNum = carNum,
            this.driverId = driverId,
            this.speed = speed,
            this.dist = dist,
            this.carX = carX,
            this.carY = carY,
            this.viewYn = viewYn,
            this.apiDtti = apiDtti
    }

    get infoDttiDisplay() {
        return changeFormat(this.infoDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get apiDttiDisplay() {
        return changeFormat(this.apiDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti,
            this.officeId = v.officeId,
            this.carNum = v.carNum,
            this.driverId = v.driverId,
            this.speed = v.speed,
            this.dist = meterToKilo(v.dist),
            this.carX = v.carX,
            this.carY = v.carY,
            this.viewYn = v.viewYn,
            this.apiDtti = v.apiDtti;

        return this;
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "speed", label: "차량속도"},
            {key: "dist", label: "이동거리 (KM)"},
            {key: "carX", label: "차량위도"},
            {key: "carY", label: "차량경도"},
            {key: "apiDtti", label: "데이터 저장일시"}
        ]
    }
}

class drivingSearchDto {
    constructor(officeId, carNum, driverId, startDate, startDay, startTime, endDate, endDay, endTime, queryDate, payType, viewYn, excelType, routeType, partnerType, regionName) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.startDate = startDate;
        this.startDay = startDay;
        this.startTime = startTime;
        this.endDate = endDate;
        this.endDay = endDay;
        this.endTime = endTime;
        this.queryDate = queryDate;
        this.payType = payType;
        this.viewYn = viewYn;
        this.excelType = excelType;
        this.routeType = routeType;
        this.partnerType = partnerType;
        this.regionName = regionName;
    }
}

class drivingCloseSearchDto {
    constructor(officeId, carNum, driverId, startDate, startDay, startTime, endDate, endDay, endTime, queryDate, payType, viewYn, excelType, routeType, partnerType, regionName, searchType, workDate) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.startDate = startDate;
        this.startDay = startDay;
        this.startTime = startTime;
        this.endDate = endDate;
        this.endDay = endDay;
        this.endTime = endTime;
        this.queryDate = queryDate;
        this.payType = payType;
        this.viewYn = viewYn;
        this.excelType = excelType;
        this.routeType = routeType;
        this.partnerType = partnerType;
        this.regionName = regionName;
        this.searchType = searchType;
        this.workDate = workDate;
    }
}

class driverIncome {
    constructor(cityName, fromDtti, untilDtti, traceId, userId) {
        this.cityName = cityName;
        this.fromDtti = fromDtti;
        this.untilDtti = untilDtti;
        this.userId = userId;
    }
}

const paymentTypeEnum = PayType

const getKeyByValue = (map, value) => {
    for (let [k, v] of Object.entries(map)) {
        if (value === v) return k;
    }
}

class drivingAggregateSummaryDto {
    constructor(payType, allPayFare, allHipassFare, allAddFare, allCallFare, allPayCount) {
        this.payType = payType
        this.allPayfare = allPayFare
        this.allHipassFare = allHipassFare
        this.allAddFare = allAddFare
        this.allFare = allPayFare + allAddFare + allCallFare + allHipassFare
        this.allCallFare = allCallFare;
        this.allPayCount = allPayCount
    }

    fromMap(v) {
        this.payType = v.payType
        this.allPayfare = v.allPayfare
        this.allHipassFare = v.allHipassFare
        this.allAddFare = v.allAddFare
        this.allFare = v.allPayfare + v.allAddFare + v.allCallFare + v.allHipassFare
        this.allCallFare = v.allCallFare
        this.allPayCount = v.allPayCount
        return this
    }

    add(v) {
        this.payType = 99
        v.map(e => {
            this.allPayfare += e.allPayfare
            this.allHipassFare += e.allHipassFare
            this.allAddFare += e.allAddFare + e.allCallFare
            this.allFare += e.allPayfare + e.allAddFare + e.allCallFare + e.allHipassFare
            this.allPayCount += e.allPayCount
        })
    }

    fields() {
        return [
            {key: "payType", label: "결제타입/금액"},
            {key: "allPayfare", label: "미터금액"},
            {key: "allCallFare", label: "호출요금"},
            {key: "allHipassFare", label: "통행요금"},
            {key: "allAddFare", label: "추가금액"},
            {key: "allFare", label: "합계금액"},
            {key: "allPayCount", label: "건수"},
        ]
    }
}

class drivingAggregateDetailDto {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, hipassFare, addFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allDist = workDist + blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
    }

    get id() {
        return `${this.carNum}_${this.minDtti}_${this.maxDtti}`;
    }

    get minDttiDisplay() {
        return changeFormat(this.minDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get maxDttiDisplay() {
        return changeFormat(this.maxDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payDttiDisplay() {
        return changeFormat(this.payDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get payFareDisplay() {
        return insertComma(this.payFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get fareDisplay() {
        return insertComma(this.fare);
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.workTime = secToHourMinute(v.workTime);
        this.allTime = secToHourMinute(v.allTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.blankDist = meterToKilo(v.blankDist).toFixed(1);
        this.allDist = meterToKilo(v.workDist + v.blankDist).toFixed(1);
        this.fare = v.fare;
        this.payFare = v.payFare;
        this.callFare = v.callFare;
        this.hipassFare = v.hipassFare;
        this.addFare = v.addFare;
        this.payType = convertPayTypeToTxt(v.payType);
        this.payDtti = v.payDtti;
        this.viewYn = v.viewYn;
        return this;
    }

    fields() {
        return [
            {key: "viewYn", label: ""},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "workTime", label: "운행시간"},
            {key: "workDist", label: "운행거리 (KM)"},
            {key: "payFare", label: "미터금액 (원)"},
            {key: "callFare", label: "호출요금 (원)"},
            {key: "hipassFare", label: "통행요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "fare", label: "합계금액 (원)"},
            {key: "payType", label: "결제타입"},
            {key: "payDtti", label: "결제시간"}
        ]
    }
}


class tachoVoucherDto {
    constructor(carNum, driverId, stDtti, edDtti, payStartDtti, distFare, addFare, hipassFee, voucherDiscount, payTotal, tripDist, payType, callFee) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.payStartDtti = payStartDtti;
        this.distFare = distFare;
        this.addFare = addFare;
        this.callFee = callFee;
        this.hipassFee = hipassFee;
        this.voucherDiscount = voucherDiscount;
        this.payTotal = payTotal;
        this.tripDist = tripDist;
        this.payType = payType;
        this.jibulFee = (parseInt(distFare) - parseInt(voucherDiscount)) + (parseInt(hipassFee)+parseInt(callFee)+parseInt(addFare));
    }

    get distFareDisplay() {
        return insertComma(this.distFare);
    }
    get voucherDiscountDisplay() {
        return insertComma(this.voucherDiscount);
    }
    get hipassFeeDisplay() {
        return insertComma(this.hipassFee);
    }
    get callFeeDisplay() {
        return insertComma(this.callFee);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get jibulFeeDisplay() {
        return insertComma(this.jibulFee);
    }
    get payTotalDisplay() {
        return insertComma(this.payTotal);
    }
    get stDttiDisplay() {
        return changeFormat(this.stDtti,'YYYY-MM-DD HH:mm:ss');
    }
    get payStartDttiDisplay() {
        return changeFormat(this.payStartDtti,'YYYY-MM-DD HH:mm:ss');
    }
    get edDttiDisplay() {
        return changeFormat(this.edDtti,'HH:mm');
    }

    get payTypeDisplay() {
        switch (toInteger(this.payType)){
            case 0 : return "카드";
            case 1 : return "카드취소";
            case 2 : return "현금영수증";
            case 3 : return "현금영수증 취소";
            case 4 : return "선불";
            case 5 : return "현금";
            case 6 : return "QR패드신용";
            case 7 : return "QR패드신용 취소";
            case 8 : return "QR패드선불";
            case 9 : return "지역화폐";
            case 10 : return "지역화폐 취소";
            case 11 : return "자동결제";
            case 12 : return "QR결제";
            case 13 : return "QR결제 취소";
            case 98 : return "타입오류";
            default : return "";
        }
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.payStartDtti = v.payStartDtti;
        this.tripDist = meterToKilo(v.tripDist).toFixed(1);
        this.payType = v.payType;
        this.distFare = v.distFare;
        this.addFare = v.addFare;
        this.callFee = v.callFee;
        this.hipassFee = v.hipassFee;
        this.payTotal = v.payTotal;
        this.jibulFee = (v.distFare - v.voucherDiscount) + (v.hipassFee + v.callFee + v.addFare);
        this.voucherDiscount = v.voucherDiscount;
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "stDtti", label: "운행시작"},
            {key: "payStartDtti", label: "운행종료"},
            {key: "tripDist", label: "운행거리 (KM)"},
            {key: "distFare", label: "승차요금 (원)"},
            {key: "voucherDiscount", label: "할인요금 (원)"},
            {key: "hipassFee", label: "통행요금 (원)"},
            {key: "callFee", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "jibulFee", label: "지불요금 (원)"},
            {key: "payTotal", label: "합계금액 (원)"},
            {key: "payType", label: "결제타입"},
            {key: "edDtti", label: "결제시간"}
        ]
    }
}

class privateTachoVoucherDto {
    constructor(carNum, stDtti, edDtti, payStartDtti, distFare, addFare, hipassFee, voucherDiscount, payTotal, tripDist, payType, callFee) {
        this.carNum = carNum;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.payStartDtti = payStartDtti;
        this.distFare = distFare;
        this.addFare = addFare;
        this.callFee = callFee;
        this.hipassFee = hipassFee;
        this.voucherDiscount = voucherDiscount;
        this.payTotal = payTotal;
        this.tripDist = tripDist;
        this.payType = payType;
        this.jibulFee = 0;
    }

    get distFareDisplay() {
        return insertComma(this.distFare);
    }
    get voucherDiscountDisplay() {
        return insertComma(this.voucherDiscount);
    }
    get hipassFeeDisplay() {
        return insertComma(this.hipassFee);
    }
    get callFeeDisplay() {
        return insertComma(this.callFee);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get jibulFeeDisplay() {
        return insertComma(this.jibulFee);
    }
    get payTotalDisplay() {
        return insertComma(this.payTotal);
    }
    get stDttiDisplay() {
        return changeFormat(this.stDtti,'YYYY-MM-DD HH:mm:ss');
    }
    get payStartDttiDisplay() {
        return changeFormat(this.payStartDtti,'YYYY-MM-DD HH:mm:ss');
    }
    get edDttiDisplay() {
        return changeFormat(this.edDtti,'HH:mm');
    }

    get payTypeDisplay() {
        switch (toInteger(this.payType)){
            case 0 : return "카드";
            case 1 : return "카드취소";
            case 2 : return "현금영수증";
            case 3 : return "현금영수증 취소";
            case 4 : return "선불";
            case 5 : return "현금";
            case 6 : return "QR패드신용";
            case 7 : return "QR패드신용 취소";
            case 8 : return "QR패드선불";
            case 9 : return "지역화폐";
            case 10 : return "지역화폐 취소";
            case 11 : return "자동결제";
            case 12 : return "QR결제";
            case 13 : return "QR결제 취소";
            case 98 : return "타입오류";
            default : return "";
        }
    }

    fromMap(v) {
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.payStartDtti = v.payStartDtti;
        this.tripDist = meterToKilo(v.tripDist).toFixed(1);
        this.payType = v.payType;
        this.distFare = v.distFare;
        this.addFare = v.addFare;
        this.callFee = v.callFee;
        this.hipassFee = v.hipassFee;
        this.payTotal = v.payTotal;
        this.voucherDiscount = v.voucherDiscount;
        this.jibulFee = (parseInt(v.distFare) - parseInt(v.voucherDiscount)) + (parseInt(v.hipassFee) + parseInt(v.callFee) + parseInt(v.addFare));

        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "stDtti", label: "운행시작"},
            {key: "payStartDtti", label: "운행종료"},
            {key: "tripDist", label: "운행거리 (KM)"},
            {key: "distFare", label: "승차요금 (원)"},
            {key: "voucherDiscount", label: "할인요금 (원)"},
            {key: "hipassFee", label: "통행요금 (원)"},
            {key: "callFee", label: "호출요금 (원)"},
            {key: "addFare", label: "추가금액 (원)"},
            {key: "jibulFee", label: "지불요금 (원)"},
            {key: "payTotal", label: "합계금액 (원)"},
            {key: "payType", label: "결제타입"},
            {key: "edDtti", label: "결제시간"}
        ]
    }
}


class companyEntity {
    constructor(
      officeId,
      name,
      address,
      phone,
      receiptNm,
      createdAt,
      updatedAt,
      type = 'NORMAL',
      regionName,
      setTime = '000000',
      ceoName,
      ceoTel,
      fax,
      area,
      useYn,
      regDtti,
      settleType = 'DRIVE',
      useTripsPw = 'N',
  ) {
        this.officeId = officeId;
        this.address = address;
        this.name = name;
        this.phone = phone;
        this.receiptNm = receiptNm;
        this.type = type;
        this.regionName = regionName;
        this.ceoName = ceoName;
        this.ceoTel = ceoTel;
        this.fax = fax;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.setTime = setTime;
        this.area = area;
        this.useYn = useYn;
        this.regDtti = regDtti;
        this.settleType = settleType;
        this.useTripsPw = useTripsPw || 'N';
        this.plainTripsPw = null;
    }

    fields() {
        return [
            {key: "officeId", label: "사업자번호"},
            {key: "address", label: "사업자주소"},
            {key: "name", label: "사업자명"},
            {key: "phone", label: "전화번호"},
            {key: "type", label: "유형"},
            {key: "area", label: "지역"},
            {key: "ceoName", label: "대표자명"},
            {key: "ceoTel", label: "대표전화"},
            {key: "setTime", label: "시간"},
            {key: "regDtti", label: "생성날짜"},
            {key: "settleTypeFormatted", label: "검색 기준"},
            {key: "useTripsPw", label: "운행 조회 비밀번호 사용 여부"},
        ]
    }
}

class employeeEntity {
    constructor(employeeId, companyRegnum, employeeNum, driverId, carNum, employeeName, employeeType) {
        this.employeeId = employeeId;
        this.companyRegnum = companyRegnum;
        this.employeeNum = employeeNum;
        this.employeeName = employeeName;
        this.driverId = driverId;
        this.carNum = carNum;
        this.employeeType = employeeType || null;
    }

    fields() {
        return [
            {key: "employeeNum", label: "사원번호"},
            {key: "displayEmployeeName", label: "기사명"},
            {key: "driverId", label: "운전자격번호"},
        ]
    }
}

class vehicleEntity {
    constructor(officeId, carNum, driverId, carType) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.carType = carType;
    }

    fields() {
        return [
            {key: "officeId", label: "운수사아이디"},
            {key: "carNum", label: "차량번호"},
            {key: "driverIdFormatted", label: "사원번호"},
            {key: "carTypeFormatted", label: "종류"}
        ]
    }
}

class transactionEntity {
    constructor(
        carNum,
        driverCertNumber,
        isOffice,
        carType,
        officeName,
        driverId,
        dtti,
        createdAt,
        fare,
    ) {
        this.carNum = carNum;
        this.driverCertNumber = driverCertNumber || '-';
        this.isOffice = isOffice;
        this.carType = carType;
        this.officeName = isOffice ? "법인" : "개인";
        if (officeName) {
            this.officeName = `법인 (${officeName})`;
        }
        this.driverId = driverId || '-';
        this.dtti = dtti;
        this.createdAt = createdAt;
        this.fare = fare;
    }

    toExcelRow() {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: this.carNum, t: "s", s: s},
            {v: this.officeName, t: "s", s: s},
            {v: this.driverId, t: "s", s: s},
            {v: this.driverCertNumber, t: "s", s: s},
            {v: this.dtti, t: "s", s: s},
            {v: this.createdAt, t: "s", s: s},
        ]
    }

    static getExcelColsDef() {
        return [
            {width: 24.0},
            {width: 24.0},
            {width: 15.0},
            {width: 12.0},
            {width: 21.0},
            {width: 21.0},
        ]
    }

    static getExcelHeaders() {
        let s = {
            alignment: {horizontal: "center"},
            font: {bold: true},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }

        return transactionEntity.fields().map(f => {
            return {v: f.label, t: "s", s: s}
        });
    }

    static fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "officeName", label: "차량종류"},
            {key: "driverId", label: "사원번호"},
            {key: "driverCertNumber", label: "운전자격번호"},
            {key: "dtti", label: "거래일시"},
            {key: "createdAt", label: "확인일시"},
        ]
    }

    static fromApi(data) {
        return new transactionEntity(
            data.carNum,
            data.driverCertNumber,
            data.office,
            data.carType,
            data.officeName,
            data.driverId,
            changeFormat(data.dtti, 'YYYY-MM-DD HH:mm:ss'),
            changeFormat(data.createdAt, 'YYYY-MM-DD HH:mm:ss'),
            data.fare,
        );
    }
}

class locationHistoryEntity {
    constructor(
        id,
        reqDtti,
        reqIp,
        officeId,
        username,
        reqPath,
        carNum,
        driverId,
        resultCt,
        stDtti,
        edDtti

    ) {
        this.id = id || '-';
        this.reqDtti = reqDtti || '-';
        this.reqIp = reqIp || '-';
        this.officeId = officeId || '-';
        this.username = username || '-';
        this.reqPath = reqPath || '-';
        this.carNum = carNum || '-';
        this.driverId = driverId || '-';
        this.resultCt = resultCt || '-';
        this.stDtti = stDtti || '-';
        this.edDtti = edDtti || '-';

    }

    toExcelRow() {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: this.id, t: "s", s: s},
            {v: this.reqDtti, t: "s", s: s},
            {v: this.reqIp, t: "s", s: s},
            {v: this.officeId, t: "s", s: s},
            {v: this.username, t: "s", s: s},
            {v: this.reqPath, t: "s", s: s},
            {v: this.carNum, t: "s", s: s},
            {v: this.driverId, t: "s", s: s},
            {v: this.resultCt, t: "s", s: s},
            {v: this.stDtti, t: "s", s: s},
            {v: this.edDtti, t: "s", s: s},

        ]
    }

    static getExcelColsDef() {
        return [
            {width: 10.0},
            {width: 21.0},
            {width: 15.0},
            {width: 12.0},
            {width: 12.0},
            {width: 40.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 21.0},
            {width: 21.0},
        ]
    }

    static getExcelHeaders() {
        let s = {
            alignment: {horizontal: "center"},
            font: {bold: true},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }

        return locationHistoryEntity.fields().map(f => {
            return {v: f.label, t: "s", s: s}
        });
    }

    static fields() {
        return [
            {key: "id", label: "No."},
            {key: "reqDtti", label: "요청일"},
            {key: "reqIp", label: "접속 IP"},
            {key: "officeId", label: "운수사 아이디"},
            {key: "username", label: "아이디"},
            {key: "reqPath", label: "요청 경로"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "resultCt", label: "조회 결과 건수"},
            {key: "stDtti", label: "조회 시작일"},
            {key: "edDtti", label: "조회 종료일"},

        ]
    }

    static fromApi(data) {

        return new locationHistoryEntity(
            data.id,
            changeFormat(data.reqDtti, 'YYYY-MM-DD HH:mm:ss'),
            data.reqIp,
            data.officeId,
            data.username,
            data.reqPath,
            data.carNum,
            data.driverId,
            data.resultCt,
            changeFormat(data.stDtti, 'YYYY-MM-DD HH:mm:ss'),
            changeFormat(data.edDtti, 'YYYY-MM-DD HH:mm:ss'),
        );
    }
}

class driveInfoDto {
    constructor(infoDtti, officeId, carNum, driverId, speed, dist, carX, carY, viewYn, apiDtti, avgSpeed, status) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.speed = speed;
        this.dist = dist;
        this.carX = carX;
        this.carY = carY;
        this.viewYn = viewYn;
        this.apiDtti = apiDtti;
        this.avgSpeed = avgSpeed;
        this.status = status;
    }

    get infoDttiDisplay() {
        return changeFormat(this.infoDtti, 'YYYY-MM-DD HH:mm:ss')
    }

    get apiDttiDisplay() {
        return changeFormat(this.apiDtti, 'YYYY-MM-DD HH:mm:ss')
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.speed = v.speed;
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        this.avgSpeed = v.avgSpeed;
        this.status = v.status;
        return this;
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "speed", label: "차량 속도"},
            {key: "avgSpeed", label: "평균 속도"},
            {key: "status", label: "상태 코드"},
            {key: "dist", label: "이동 거리"},
            {key: "carX", label: "차량 위도"},
            {key: "carY", label: "차량 경도"},
            {key: "apiDtti", label: "데이터 저장일시"},

        ]
    }

}

class cityInternalDto {
    constructor(cityName, searchDate, stDate, stTime, maxFare, minFare, totalFare, avgFare, q1, q2, q3, driverCnt, medianFare, dayOfWeek) {
        this.cityName = cityName;
        this.searchDate = searchDate;
        this.stDate = stDate;
        this.stTime = stTime;
        this.maxFare = maxFare;
        this.minFare = minFare;
        this.totalFare = totalFare;
        this.avgFare = avgFare;
        this.q1 = q1;
        this.q2 = q2;
        this.q3 = q3;
        this.driverCnt = driverCnt;
        this.medianFare = medianFare;
        this.dayOfWeek = dayOfWeek;
    }

    fromMap(v) {
        this.cityName = v.cityName;
        this.searchDate = v.searchDate;
        this.stDate = v.stDate;
        this.stTime = v.stTime;
        this.maxFare = v.maxFare;
        this.minFare = v.minFare;
        this.totalFare = v.totalFare;
        this.avgFare = v.avgFare;
        this.q1 = v.q1;
        this.q2 = v.q2;
        this.q3 = v.q3;
        this.driverCnt = v.driverCnt;
        this.medianFare = v.medianFare;
        this.dayOfWeek = v.dayOfWeek;
        return this;
    }

    fields() {
        return [
            {key: "cityName", label: "지역"},
            {key: "searchDate", label: "검색기간"},
            {key: "stTime", label: "시간"},
            {key: "dayOfWeek", label: "요일"},
            {key: "driverCnt", label: "기사수"},
            {key: "avgFare", label: "평균 수입금액 (원)"},
            {key: "medianFare", label: "중간 수입금액(원)"},
            // {key: "maxFare", label: "최대 운임요금 (원)"},
            // {key: "minFare", label: "최소 운임요금 (원)"},
            {key: "totalFare", label: "총 운임요금 (원)"},
            {key: "q1", label: "q1"},
            {key: "q2", label: "q2"},
            {key: "q3", label: "q3"}
        ]
    }

}

class cityStatDto {
    constructor(cityName, searchDate, stDate, stTime, maxFare, minFare, totalFare, avgFare, q1, q2, q3, q60, q70, q80, q90, driverCnt, medianFare, dayOfWeek) {
        this.cityName = cityName;
        this.searchDate = searchDate;
        this.stDate = stDate;
        this.stTime = stTime;
        this.maxFare = maxFare;
        this.minFare = minFare;
        this.totalFare = totalFare;
        this.avgFare = avgFare;
        this.q1 = q1;
        this.q2 = q2;
        this.q3 = q3;
        this.q60 = q60;
        this.q70 = q70;
        this.q80 = q80;
        this.q90 = q90;
        this.driverCnt = driverCnt;
        this.medianFare = medianFare;
        this.dayOfWeek = dayOfWeek;
    }

    get stDateDisplay() {
        return changeFormat(this.stDate, 'YYYY-MM-DD')
    }

    get stTimeDisplay() {
        return this.stTime.toString().substring(0,2) ;
    }

    get avgFareDisplay() {
        return insertComma(this.avgFare)
    }

    get medianFareDisplay() {
        return insertComma(this.medianFare)
    }

    get totalFareDisplay() {
        return insertComma(this.totalFare)
    }

    get q1Display() {
        return insertComma(this.q1)
    }

    get q2Display() {
        return insertComma(this.q2)
    }

    get q3Display() {
        return insertComma(this.q3)
    }

    get q60Display() {
        return insertComma(this.q60)
    }

    get q70Display() {
        return insertComma(this.q70)
    }

    get q80Display() {
        return insertComma(this.q80)
    }

    get q90Display() {
        return insertComma(this.q90)
    }

    fromMap(v) {
        this.cityName = v.cityName;
        this.searchDate = v.searchDate;
        this.stDate = v.stDate;
        this.stTime = v.stTime;
        this.maxFare = v.maxFare;
        this.minFare = v.minFare;
        this.totalFare = v.totalFare;
        this.avgFare = v.avgFare;
        this.q1 = v.q1;
        this.q2 = v.q2;
        this.q3 = v.q3;
        this.q60 = v.q60;
        this.q70 = v.q70;
        this.q80 = v.q80;
        this.q90 = v.q90;
        this.driverCnt = v.driverCnt;
        this.medianFare = v.medianFare;
        this.dayOfWeek = v.dayOfWeek;
        return this;
    }

    fields() {
        return [
            {key: "cityName", label: "지역"},
            {key: "stDate", label: "시작일자"},
            {key: "stTime", label: "시간"},
            {key: "dayOfWeek", label: "요일"},
            {key: "driverCnt", label: "기사수(명)"},
            {key: "avgFare", label: "평균 수입금액 (원)"},
            {key: "medianFare", label: "중간 수입금액(원)"},
            {key: "totalFare", label: "총 운임요금 (원)"},
            {key: "q1", label: "q1"},
            {key: "q2", label: "q2"},
            {key: "q3", label: "q3"},
            {key: "q60", label: "q60"},
            {key: "q70", label: "q70"},
            {key: "q80", label: "q80"},
            {key: "q90", label: "q90"},
        ]
    }

}

class driverIncomeDto {
    constructor(infoDtti, officeId, carNum, driverId, dist, carX, carY, apiDtti) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.dist = dist;
        this.carX = carX;
        this.carY = carY;
        this.apiDtti = apiDtti;
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.driverId = v.driverId;
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        return this;
    }

    fields() {
        return [
            {key: "apiDtti", label: "No"},
            {key: "apiDtti", label: "운수사"},
            {key: "dist", label: "사원번호"},
            {key: "viewYn", label: "운행시작"},
            {key: "viewYn", label: "운행종료"},
            {key: "viewYn", label: "총미터금액"},
            {key: "viewYn", label: "평균수익"}

        ]
    }

}

class acrmDataDto {
    constructor(eventDtti, cityName, carNum, driverId, eventCode) {
        this.eventDtti = eventDtti;
        this.cityName = cityName;
        this.carNum = carNum;
        this.driverId = driverId;
        this.eventCode = eventCode;
    }

    get eventDttiDisplay() {
        return changeFormat(this.eventDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get eventCodeDisplay() {
        switch (this.eventCode.toString()) {
            case "000":
                return "급가속";
            case "001":
                return "급감속";
            case "002":
                return "급정거";
            default :
                return '';
        }
    }

    fromMap(v) {
        this.eventDtti = v.eventDtti;
        this.cityName = v.cityName;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.eventCode = v.eventCode;
        return this;
    }

    fields() {
        return [
            {key: "eventDtti", label: "이벤트 발생시간"},
            {key: "cityName", label: "지역"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "운전자"},
            {key: "eventCode", label: "이벤트"},
        ]
    }
}

class buttonEventDto {
    constructor(infoDtti, officeId, carNum, driverId, driveKey, driveSubkey, buttonVal, payType, fare, callFare, addFare, carX, carY, dist, apiDtti, viewYn, carType, cityName, hipassFare, voucherFare, driverLicense, duration) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driveKey = driveKey;
        this.driveSubkey = driveSubkey;
        this.buttonVal = buttonVal;
        this.payType = payType;
        this.fare = fare;
        this.callFare = callFare;
        this.addFare = addFare;
        this.carX = carX;
        this.carY = carY;
        this.dist = dist;
        this.viewYn = viewYn;
        this.apiDtti = apiDtti;
        this.carType = carType;
        this.cityName = cityName;
        this.hipassFare = hipassFare;
        this.voucherFare = voucherFare;
        this.driverLicense = driverLicense;
        this.duration = duration;
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.driveKey = v.driveKey;
        this.driveSubkey = v.driveSubkey;
        this.buttonVal = `${MeterStatusType[v.buttonVal]}(${v.buttonVal})`;
        this.payType = `${PayType[v.payType]}`;
        this.fare = v.fare;
        this.callFare = v.callFare;
        this.addFare = v.addFare;
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        this.carType = v.carType;
        this.cityName = v.cityName;
        this.hipassFare = v.hipassFare;
        this.voucherFare = v.voucherFare;
        this.driverLicense = v.driverLicense;
        this.duration = v.duration;
        return this;
    }

    static fromApi(data) {
        const btnEvent = new buttonEventDto();
        btnEvent.fromMap(data);
        return btnEvent;
    }

    get infoDttiDisplay() {
        return changeFormat(this.infoDtti, 'YYYY-MM-DD HH:mm:ss')
    }

    get apiDttiDisplay() {
        return changeFormat(this.apiDtti, 'YYYY-MM-DD HH:mm:ss')
    }

    get fareDisplay() {
        return insertComma(this.fare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get voucherFareDisplay() {
        return insertComma(this.voucherFare);
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "driveKey", label: "순번"},
            {key: "driveSubkey", label: "타코용 서브키"},
            {key: "buttonVal", label: "미터기 상태"},
            {key: "payType", label: "결제타입"},
            {key: "fare", label: "요금"},
            {key: "callFare", label: "호출 요금"},
            {key: "addFare", label: "추가 요금"},
            {key: "hipassFare", label: "통행 요금"},
            {key: "voucherFare", label: "바우처 요금"},
            {key: "carX", label: "차량 위도"},
            {key: "carY", label: "차량 경도"},
            {key: "dist", label: "이동 거리"},
            {key: "apiDtti", label: "저장 일시"},
            {key: "carType", label: "영업 타입"},
            {key: "cityName", label: "영업 지역"},
            {key: "driverLicense", label: "기사 자격번호"},
            {key: "duration", label: "공차시간"}

        ]
    }
}

class privateButtonEventDto {
    constructor(infoDtti, officeId, carNum, driverId, driveKey, driveSubkey, buttonVal, payType, fare, callFare, addFare, carX, carY, dist, apiDtti, viewYn, carType, cityName, hipassFare, voucherFare, driverLicense, duration) {
        this.infoDtti = infoDtti;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driveKey = driveKey;
        this.driveSubkey = driveSubkey;
        this.buttonVal = buttonVal;
        this.payType = payType;
        this.fare = fare;
        this.callFare = callFare;
        this.addFare = addFare;
        this.carX = carX;
        this.carY = carY;
        this.dist = dist;
        this.viewYn = viewYn;
        this.apiDtti = apiDtti;
        this.carType = carType;
        this.cityName = cityName;
        this.hipassFare = hipassFare;
        this.voucherFare = voucherFare;
        this.driverLicense = driverLicense;
        this.duration = duration;
    }

    get infoDttiDisplay() {
        return changeFormat(this.infoDtti, 'YYYY-MM-DD HH:mm:ss')
    }

    get apiDttiDisplay() {
        return changeFormat(this.apiDtti, 'YYYY-MM-DD HH:mm:ss')
    }

    fromMap(v) {
        this.infoDtti = v.infoDtti;
        this.officeId = v.officeId;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.driveKey = v.driveKey;
        this.driveSubkey = v.driveSubkey;
        this.buttonVal = `${MeterStatusType[v.buttonVal]}(${v.buttonVal})`;
        this.payType = `${PayType[v.payType]}`;
        this.fare = v.fare;
        this.callFare = v.callFare;
        this.addFare = v.addFare;
        this.carX = v.carX.toString();
        this.carY = v.carY.toString();
        this.dist = meterToKilo(v.dist).toFixed(1);
        this.viewYn = v.viewYn;
        this.apiDtti = v.apiDtti;
        this.carType = v.carType;
        this.cityName = v.cityName;
        this.hipassFare = v.hipassFare;
        this.voucherFare = v.voucherFare;
        this.driverLicense = v.driverLicense;
        this.duration = v.duration;
        return this;
    }

    get fareDisplay() {
        return insertComma(this.fare);
    }
    get callFareDisplay() {
        return insertComma(this.callFare);
    }
    get addFareDisplay() {
        return insertComma(this.addFare);
    }
    get hipassFareDisplay() {
        return insertComma(this.hipassFare);
    }
    get voucherFareDisplay() {
        return insertComma(this.voucherFare);
    }

    fields() {
        return [
            {key: "infoDtti", label: "데이터 생성일시"},
            {key: "officeId", label: "사업자번호"},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "사원번호"},
            {key: "driveKey", label: "순번"},
            {key: "driveSubkey", label: "타코용 서브키"},
            {key: "buttonVal", label: "미터기 상태"},
            {key: "payType", label: "결제타입"},
            {key: "fare", label: "요금"},
            {key: "callFare", label: "호출 요금"},
            {key: "addFare", label: "추가 요금"},
            {key: "hipassFare", label: "통행 요금"},
            {key: "voucherFare", label: "바우처 요금"},
            {key: "carX", label: "차량 위도"},
            {key: "carY", label: "차량 경도"},
            {key: "dist", label: "이동 거리"},
            {key: "apiDtti", label: "저장 일시"},
            {key: "carType", label: "영업 타입"},
            {key: "cityName", label: "영업 지역"},
            {key: "driverLicense", label: "기사 자격번호"},
            {key: "duration", label: "공차시간"}
        ]
    }
}

class drivingGraphSummaryDto {
    constructor(allPayFare, allAddFare, allCallFare, allWorkDist, allBlankDist, allWorkTime, allBlankTime, allWorkCount, allCarCount, allDriverCount, carNum, driverId, summaryPay, allHipassFare, workTime, workDay) {
        this.allPayFare = allPayFare;
        this.allAddFare = allAddFare;
        this.allCallFare = allCallFare;
        this.allWorkDist = allWorkDist;
        this.allBlankDist = allBlankDist;
        this.allWorkTime = allWorkTime;
        this.allBlankTime = allBlankTime;
        this.allWorkCount = allWorkCount;
        this.allCarCount = allCarCount;
        this.allDriverCount = allDriverCount;
        this.carNum = carNum;
        this.driverId = driverId;
        this.summaryPay = summaryPay;
        this.allDist = allWorkDist + allBlankDist;
        this.allTime = allWorkTime + allBlankTime;
        this.allHipassFare = allHipassFare;
        this.workTime = workTime;
        this.workDay = workDay;
    }

    fromMap(q, v, l) {
        this.allPayFare = v.allPayFare;
        this.allAddFare = v.allAddFare;
        this.allCallFare = v.allCallFare;
        this.allWorkDist = meterToKilo(v.allWorkDist).toFixed(1);
        this.allBlankDist = meterToKilo(v.allBlankDist).toFixed(1);
        this.allWorkTime = getHourFromSec(v.allWorkTime);
        this.allBlankTime = getHourFromSec(v.allBlankTime);
        this.allWorkCount = v.allWorkCount;
        this.allCarCount = v.allCarCount;
        this.allDriverCount = v.allDriverCount;
        this.carNum = q.carNum;
        this.driverId = q.driverId;
        this.summaryPay = l;
        this.allDist = meterToKilo(v.allWorkDist + v.allBlankDist).toFixed(1);
        this.allTime = getHourFromSec(v.allWorkTime + v.allBlankTime);
        this.allFare = v.allPayFare + v.allAddFare + v.allCallFare + v.allHipassFare;
        this.workTime = v.workTime;
        this.workDay = v.workDay;
        return this;
    }

    fields() {
        return [
            {key: "allFare", label: "총 합계금액"}, //0
            {key: "allAddFare", label: "총 추가금액"}, //1
            {key: "allCallFare", label: "총 호출금액"}, //2
            {key: "allWorkDist", label: "영업거리"},//3
            {key: "allBlankDist", label: "주행거리"},//4
            {key: "allWorkTime", label: "영업시간"},//5
            {key: "allBlankTime", label: "주행시간"},//6
            {key: "allWorkCount", label: "총 운행횟수"},//7
            {key: "allCarCount", label: "총 차량대수"},//8
            {key: "allDriverCount", label: "총 기사수"},//9
            {key: "carNum", label: "차량번호"},//10
            {key: "driverId", label: "사원번호"},//11
            {key: "allDist", label: "총 운행거리"},//12
            {key: "allTime", label: "총 영업시간"},//13
            {key: "workTime", label: "영업시간"},//14
            {key: "workDay", label: "영업일자"},//15

        ]
    }
}

class drivingGraphRecordDto {
    constructor(minDtti, maxDtti, infoDtti, state, workTime, workDist, fare, payType) {
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.infoDtti = infoDtti;
        this.state = state;
        this.workTime = workTime;
        this.workDist = workDist;
        this.fare = fare;
        this.payType = payType;
    }

    get minDttiDisplay() {
        return changeFormat(this.minDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get maxDttiDisplay() {
        return changeFormat(this.maxDtti, 'YYYY-MM-DD HH:mm:ss');
    }

    get fareDisplay() {
        return insertComma(this.fare);
    }

    fromMap(v) {
        this.minDtti = v.minDtti;
        this.maxDtti = v.maxDtti;
        this.infoDtti = v.infoDtti;
        this.state = v.state;
        this.workTime = secToHourMinute(v.workTime);
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.fare = v.fare;
        this.payType = PayType[v.payType];
        return this;
    }

    fields() {
        return [
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            // {key: "infoDtti", label: "운행중"},
            // {key: "state", label: "운행상태"},
            {key: "workTime", label: "영업시간 (초)"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "fare", label: "결제금액 (원)"},
            // {key: "payType", label: "결제타입"},
        ]
    }
}

class drivingGraphPrintDto {
    constructor(minDtti, maxDtti, infoDtti, state, workTime, workDist, fare, payType) {
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workDist = workDist;
        this.fare = fare;
    }

    fromMap(v) {
        this.minDtti = changeFormat(v.minDtti, 'HH:mm:ss');
        this.maxDtti = changeFormat(v.maxDtti, 'HH:mm:ss');
        this.workDist = meterToKilo(v.workDist).toFixed(1);
        this.fare = v.fare;
        return this;
    }

    fields() {
        return [
            {key: "minDtti", label: "운행시작"},
            {key: "maxDtti", label: "운행종료"},
            {key: "workDist", label: "영업거리 (KM)"},
            {key: "fare", label: "결제금액 (원)"},
        ]
    }
}

class acrmEventErrorDto {
    constructor(carNum, carType, details, driverId, eventCode, eventDtti, fileName, id) {
        this.carNum = carNum;
        this.carType = carType;
        this.details = details;
        this.driverId = driverId;
        this.eventCode = eventCode;
        this.eventDtti = eventDtti;
        this.fileName = fileName;
        this.id = id;
    }

    fromMap(v) {
        this.eventDtti = changeFormat(v.eventDtti, 'HH:mm:ss');
        return this;
    }

    fields() {
        return [
            {key: "carNum", label: "차량번호"},
            {key: "carType", label: "법인/개인"},
            {key: "driverId", label: "사원번호"},
            {key: "eventCode", label: "이벤트 코드"},
            {key: "eventDtti", label: "일시"},
            {key: "fileName", label: "파일명"}
        ]
    }
}

class appmeterDto {
    constructor(appmeterId, mdn, officeId, officeNm, carNum, carVin, license, regionName, carType, unitSn, speedDownRatio, rpmDownRatio, distCorrection, regDt, createdAt, updatedAt) {
        this.appmeterId = appmeterId;
        this.mdn = mdn;
        this.officeId = officeId;
        this.officeNm = officeNm;
        this.carNum = carNum;
        this.carVin = carVin;
        this.license = license;
        this.regionName = regionName;
        this.carType = carType;
        this.unitSn = unitSn;
        this.speedDownRatio = speedDownRatio;
        this.rpmDownRatio = rpmDownRatio;
        this.distCorrection = distCorrection;
        this.regDt = regDt;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }

    fromMap(v) {
        this.appmeterId = v.appmeterId;
        this.mdn = v.mdn;
        this.officeId = v.officeId;
        this.officeNm = v.officeNm;
        this.carNum = v.carNum;
        this.carVin = v.carVin;
        this.license = v.license;
        this.regionName = v.regionName;
        this.carType = v.carType;
        this.unitSn = v.unitSn;
        this.speedDownRatio = v.speedDownRatio;
        this.rpmDownRatio = v.rpmDownRatio;
        this.distCorrection = v.distCorrection;
        this.regDt = v.regDt;
        this.createdAt = v.createdAt;
        this.updatedAt = v.updatedAt;
        return v;
    }

    fields() {
        return [
            {key: "appmeterId", label: "앱미터기 아이디"},
            {key: "mdn", label: "단말전화번호"},
            {key: "officeId", label: "사업자번호"},
            {key: "officeNm", label: "운송사업자명"},
            {key: "carNum", label: "차량번호"},
            {key: "carVin", label: "차대번호"},
            {key: "license", label: "자격면허번호"},
            {key: "carType", label: "유형"},
            {key: "region", label: "지역"},
            {key: "unitSn", label: "단말기 시리얼 번호"},
            {key: "speedDownRatio", label: "속도 감속률"},
            {key: "rpmDownRatio", label: "RPM 감속률"},
            {key: "distCorrection", label: "거리보정"},
            {key: "regDt", label: "설치등록일자"},
            {key: "createdAt", label: "생성일"},
            {key: "updatedAt", label: "수정일"}
        ];
    }
}

class drivingGraphDetailDto {
    constructor(speed, dist, infoDtti) {
        this.speed = speed;
        this.dist = dist;
        this.infoDtti = infoDtti;
    }
}

class drivingGraphOnHistDto {
    constructor(startDate, endDate) {
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

class vehicleQueryParam {
    constructor(officeId, queryType, queryValue, carType) {
        this.officeId = officeId
        this.queryType = queryType
        this.queryValue = queryValue
        this.carType = carType
    }
}

class lastTransactionQueryParam {
    constructor(
        region,
        officeId,
        carNum,
        onlyWithOffice,
        onlyWithPayment,
        page,
        size,
    ) {
        this.region = region;
        this.officeId = officeId;
        this.carNum = carNum;
        this.onlyWithOffice = typeof onlyWithOffice === 'boolean' ? onlyWithOffice : null;
        this.onlyWithPayment = typeof onlyWithPayment === 'boolean' ? onlyWithPayment : null;
        this.page = page || 0;
        this.size = size || 10;
    }

    o

    toQueryParams() {
        return objectToQueryString(this);
    }
}

class locationHistoryQueryParam {
    constructor(
        officeId,
        carNum,
        reqUsername,
        dttiProp,
        fromDtti,
        untilDtti,
        page,
        size,
        orders,
    ) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.reqUsername = reqUsername;
        this.dttiProp = dttiProp;
        this.fromDtti = fromDtti;
        this.untilDtti = untilDtti;
        this.page = page || 0;
        this.size = size || 10;
        this.orders = orders;
    }

    toQueryParams() {
        return objectToQueryString(this);
    }
}

class companyQueryParam {
    constructor(officeId, name, address, phone, receiptNm, periodType, startDate, endDate, type, regionName, ceoName, ceoTel, fax, setTime, area) {
        this.officeId = officeId;
        this.name = name;
        this.address = address;
        this.phone = phone;
        this.receiptNm = receiptNm;
        this.periodType = periodType;
        this.startDate = startDate;
        this.endDate = endDate;
        this.type = type;
        this.regionName = regionName;
        this.ceoName = ceoName;
        this.ceoTel = ceoTel;
        this.fax = fax;
        this.setTime = setTime;
        this.area = area;
    }
}

class appmeterQueryParam {
    constructor(mdn, officeId, officeNm, carNum, carVin, license, region, carType, unitSn, startDate, endDate) {
        this.mdn = mdn;
        this.officeId = officeId;
        this.officeNm = officeNm;
        this.carNum = carNum;
        this.carVin = carVin;
        this.license = license;
        this.region = region;
        this.carType = carType;
        this.unitSn = unitSn;
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

class employeeQueryParam {
    constructor(companyRegnum, queryType, queryValue) {
        this.companyRegnum = companyRegnum
        this.queryType = queryType
        this.queryValue = queryValue
    }
}

const jobTypeEnum = {
    A: "A",
    B: "B"
}

const jobPositionTypeEnum = {
    A: "A",
    B: "B"
}

const jobStateEnum = {
    Y: "Y",
    N: "N"
}

const drivingTypeEnum = {
    NORMAL: "법인",
    INDIVIDUAL: "개인"
}

const drivingStateEnum = {
    OPEN: "OPEN",
    CLOSE: "CLOSE"
}

const regionTypeEnum = {
    KRSEL: "KRSEL",
    KRSUO: "KRSUO",
    KRSGM: "KRSGM",
    KRCHO: "KRCHO",
    KRTAE: "KRTAE",
    KRPUS: "KRPUS"
}

const appmeterCarTypeEnum = {
    21: "NORMAL",
    22: "INDIVIDUAL",
    71: 'COMPANY_ELECTRIC',
    72: 'INDIVIDUAL_ELECTRIC'
}

const carTypeEnum = {
    NORMAL: "NORMAL",
    INDIVIDUAL: "INDIVIDUAL",
    COMPANY_ELECTRIC: 'COMPANY_ELECTRIC',
    INDIVIDUAL_ELECTRIC: 'INDIVIDUAL_ELECTRIC'
}

export const carTypeNames = {
    21: '법인',
    22: '개인',
    71: '법인 전기',
    72: '개인 전기'
}

const companyTypeEnum = {
    NORMAL: "법인",
    INDIVIDUAL: "개인",
}

const periodTypeEnum = {
    CREATED: "CREATED",
    UPDATED: "UPDATED"
}
const baseUrl = `${setting.url.tacho}`
const tachodUrl = `${setting.url.tachod}`

class tachoDataDto {
    constructor(select, carNum, driverId, fileName) {
        this.select = select;
        this.carNum = carNum;
        this.driverId = driverId;
        this.fileName = fileName;
    }

    fromMap(v, date) {
        this.select = "";
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.fileName = `${date}_${v.carNum.slice(5, 9)}_${v.driverId}_1.txt`;
        return this;
    }

    toApiDto() {
        return {carNum: this.carNum, driverId: this.driverId};
    }

    fields() {
        return [
            {key: "select", label: ""},
            {key: "carNum", label: "차량번호"},
            {key: "driverId", label: "운전자"},
            {key: "fileName", label: "파일명"}
        ];
    }
}

class commuteManagementEntity {
    constructor(seq, carNum, driverId, stDtti, edDtti, officeId) {
        this.seq = seq;
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.officeId = officeId;
    }

    fromMap(v) {
        this.seq = v.seq;
        this.carNum = v.carNum;
        this.driverId = v.driverId;
        this.stDtti = v.stDtti;
        this.edDtti = v.edDtti;
        this.officeId = v.officeId;
        return this;
    }

    fields() {
        return [
            {key: "isChecked", label: ""},
            {key: "driverId", label: "사원번호"},
            {key: "carNum", label: "차량번호"},
            {key: "stDtti", label: "출근시간"},
            {key: "edDtti", label: "퇴근시간"}
        ]
    }
}

class TripDto {
    constructor(
        stDtti,
        payStartDtti,
        edDtti,
        officeId,
        carNum,
        driverId,
        distFare,
        addFare,
        callFee,
        hipassFee,
        voucherDiscount,
        payTotal,
        payType,
        tripDist,
        emptyDist,
        isDeleted,
    ) {
        this.setStDtti(stDtti);
        this.setEdDtti(edDtti);
        this.payStartDtti = payStartDtti;
        this.payStartDttiJs = dayjs(payStartDtti, 'YYYYMMDDHHmmss');
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.distFare = distFare;
        this.addFare = addFare;
        this.callFee = callFee;
        this.hipassFee = hipassFee;
        this.voucherDiscount = voucherDiscount;
        this.payTotal = payTotal;
        this.payType = parseInt(payType, 10);
        this.tripDist = tripDist;
        this.emptyDist = emptyDist;
        this.isDeleted = isDeleted;
    }

    setStDtti(dtti) {
        this.stDtti = dtti;
        this.stDttiJs = dayjs(dtti, 'YYYYMMDDHHmmss');
    }

    setEdDtti(dtti) {
        this.edDtti = dtti;
        this.edDttiJs = dayjs(dtti, 'YYYYMMDDHHmmss');
    }

    get displayStDtti() {
        return this.stDttiJs.format('YYYY-MM-DD HH:mm:ss');
    }

    get displayEdDtti() {
        return this.edDttiJs.format('YYYY-MM-DD HH:mm:ss');
    }

    get displayPayStartDtti() {
        return this.payStartDttiJs.format('YYYY-MM-DD HH:mm:ss');
    }

    get displayRideTime() {
        return secToHourMinute(this.getRideTimeInSeconds())
    }

    get displayTripDist() {
        return displayDistance(this.tripDist);
    }

    get displayTripDistKm() {
        return `${this.displayTripDist}km`;
    }

    get displayDistFare() {
        return displayCash(this.distFare);
    }

    get displayCallFee() {
        return displayCash(this.callFee);
    }

    get displayHipassFee() {
        return displayCash(this.hipassFee);
    }

    get displayAddFare() {
        return displayCash(this.addFare);
    }

    get displayVoucherDiscount() {
        return this.voucherDiscount > 0 ? `-${displayCash(this.voucherDiscount)}` : '0';
    }

    get displayPayTotal() {
        return displayCash(this.payTotal);
    }

    get displayPayType() {
        return convertPayTypeToTxt(this.payType);
    }

    getPayStartDttiPercentageOfRide() {
        const rideTime = this.getRideTimeInSeconds();
        const payStartOffset = this.payStartDttiJs.diff(this.stDttiJs, 'second');
        if (rideTime === 0) {
            return 0;
        }
        return payStartOffset / rideTime;
    }

    getPayTypeName() {
        return PayType[this.payType] || '기타';
    }

    get rideTimeInSeconds() {
        return this.getRideTimeInSeconds();
    }

    getRideTimeInSeconds() {
        return this.edDttiJs.diff(this.stDttiJs, 'second');
    }

    getStDttiInFormat(format) {
        return this.stDttiJs.format(format);
    }

    getEdDttiInFormat(format) {
        return this.edDttiJs.format(format);
    }

    getPayStartDttiInFormat(format) {
        return dayjs(this.payStartDtti, 'YYYYMMDDHHmmss').format(format);
    }

    static fromApi(v) {
        return new TripDto(
            v.stDtti,
            v.payStartDtti,
            v.edDtti,
            v.officeId,
            v.carNum,
            v.driverId,
            v.distFare,
            v.addFare,
            v.callFee,
            v.hipassFee,
            v.voucherDiscount,
            v.payTotal,
            v.payType,
            v.tripDist,
            v.emptyDist,
            v.isDeleted,
        );
    }
}

class RouteDetailDto {
    constructor(
        infoDtti,
        officeId,
        carNum,
        driverId,
        carX,
        carY,
        speed,
        avgSpeed,
        dist,
        status
    ) {
        this.infoDtti = infoDtti;
        this.infoDttiJs = dayjs(infoDtti, 'YYYYMMDDHHmmss');
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;

        this.carX = carX || 0;
        this.carY = carY || 0;

        this.speed = speed;
        this.avgSpeed = avgSpeed;
        this.dist = dist;
        this.status = status;
    }

    get lat() {
        return this.carX;
    }

    get lng() {
        return this.carY;
    }

    static fromApi(v) {
        return new RouteDetailDto(
            v.infoDtti,
            v.officeId,
            v.carNum,
            v.driverId,
            v.carX,
            v.carY,
            v.speed,
            v.avgSpeed,
            v.dist,
            v.status
        );
    }
}

class RouteRangeDto {
    constructor(
        stDtti,
        edDtti,
        officeId,
        carNum,
        driverId,
        dist
    ) {
        this.setStDtti(stDtti);
        this.setEdDtti(edDtti);
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.dist = typeof dist !== 'number' ? null : dist;
    }

    setStDtti(value) {
        this.stDtti = value;
        this.stDttiJs = dayjs(value, 'YYYYMMDDHHmmss');
    }

    setEdDtti(value) {
        this.edDtti = value;
        this.edDttiJs = dayjs(value, 'YYYYMMDDHHmmss');
    }

    get displayStDtti() {
        return this.stDttiJs.format('YYYY-MM-DD HH:mm:ss');
    }

    get displayEdDtti() {
        return this.edDttiJs.format('YYYY-MM-DD HH:mm:ss');
    }

    get displayDuration() {
        return secToHourMinute(this.getDurationInSeconds())
    }

    getDurationInSeconds() {
        return this.edDttiJs.diff(this.stDttiJs, 'second');
    }

    get displayDist() {
        if (this.dist === null) {
            return '-';
        }

        return displayDistance(this.dist);
    }

    get displayDistKm() {
        if (this.dist === null) {
            return '-';
        }

        return `${meterToKilo(this.dist).toFixed(1)}km`;
    }

    clone() {
        return new RouteRangeDto(
            this.stDtti,
            this.edDtti,
            this.officeId,
            this.carNum,
            this.driverId,
            this.dist
        );
    }

    static fromApi(v) {
        return new RouteRangeDto(
            v.stDtti,
            v.edDtti,
            v.officeId,
            v.carNum,
            v.driverId,
            v.dist
        );
    }
}

class CarRouteDetailsAggDto {
    constructor(
        officeId,
        carNum,
        driverId,
        dist,
        avgSpeed,
    ) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.dist = dist;
        this.avgSpeed = avgSpeed;
    }

    static fromApi(v) {
        return new CarRouteDetailsAggDto(
            v.officeId,
            v.carNum,
            v.driverId,
            v.dist,
            v.avgSpeed,
        );
    }
}

const AcrmEventErrorCodeType = {
    '000': '급가속',
    '001': '급감속',
    '002': '급정거',
}

class AcrmEventErrorDetailDto {
    constructor(
        dist,
        totalDist,
        eventDtti,
        speed,
        rpm,
        brakePress,
        location,
        angle,
        vx,
        vy,
        state,
    ) {
        this.dist = dist;
        this.totalDist = totalDist;
        this.eventDtti = eventDtti;
        this.eventDttiJs = dayjs(eventDtti, 'YYYYMMDDHHmmss');
        this.speed = speed;
        this.rpm = rpm;
        this.brakePress = brakePress;
        this.location = location;
        this.angle = angle;
        this.vx = vx;
        this.vy = vy;
        this.state = state;
    }

    get lat() {
        return this.location.x;
    }

    get lng() {
        return this.location.y;
    }

    static fromApi(v) {
        return new AcrmEventErrorDetailDto(
            v.dist,
            v.totalDist,
            v.eventDtti,
            v.speed,
            v.rpm,
            v.brakePress,
            v.location,
            v.angle,
            v.vx,
            v.vy,
            v.state,
        );
    }
}

class AcrmEventErrorDto {
    constructor(
        id,
        officeId,
        carNum,
        driverId,
        carType,
        eventDtti,
        eventCode,
        cityName,
        location,
        details,
    ) {
        this.id = id;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.carType = carType;
        this.setEventDtti(eventDtti);
        this.eventCode = eventCode;
        this.cityName = cityName;
        this.location = location;
        this.details = details || [];
    }

    get lat() {
        return this.location.x;
    }

    get lng() {
        return this.location.y;
    }

    get displayEventDtti() {
        return this.eventDttiJs.format('YYYY-MM-DD HH:mm:ss');
    }

    get stDtti() {
        if (this.details.length === 0) {
            return this.eventDtti;
        }

        return this.details[0].eventDtti;
    }

    get stDttiJs() {
        if (this.details.length === 0) {
            return this.eventDttiJs;
        }

        return this.details[0].eventDttiJs;
    }

    get edDtti() {
        if (this.details.length === 0) {
            return this.eventDtti;
        }

        return this.details[this.details.length - 1].eventDtti;
    }

    get edDttiJs() {
        if (this.details.length === 0) {
            return this.eventDttiJs;
        }

        return this.details[this.details.length - 1].eventDttiJs;
    }

    get displaySpeedDiff() {
        const speedDiff = this.getSpeedDiff();
        if (speedDiff === null) {
            return '-';
        }

        return `${speedDiff > 0 ? '+' : ''}${speedDiff}km/h`;
    }

    getSpeedDiff() {
        const detailIdx = this.details.findIndex(detail => detail.eventDtti === this.eventDtti);
        if (detailIdx <= 0) {
            return null;
        }

        const detailDto = this.details[detailIdx];
        const prevDetailDto = this.details[detailIdx - 1];
        return detailDto.speed - prevDetailDto.speed;
    }

    setEventDtti(value) {
        this.eventDtti = value;
        this.eventDttiJs = dayjs(value, 'YYYYMMDDHHmmss');
    }

    get eventCodeName() {
        return this.getEventCodeName();
    }

    getEventCodeName() {
        return AcrmEventErrorCodeType[this.eventCode] || '알수없음';
    }

    static fromApi(v) {
        return new AcrmEventErrorDto(
            v.id,
            v.officeId,
            v.carNum,
            v.driverId,
            v.carType,
            v.eventDtti,
            v.eventCode,
            v.cityName,
            v.location,
            v.details
                ? v.details.map(v => AcrmEventErrorDetailDto.fromApi(v)) : [],
        );
    }
}

const tripTransactionPlatforms = {
    EZL: 'EZL',
    TMONEY: 'TMONEY',
    KAKAO: 'KAKAO',
    KAKAO_SERVICE: 'KAKAO_SERVICE',
    KONA: 'KONA',
}

const tripTransactionPlatformData = {
    [tripTransactionPlatforms.EZL]: {
        name: '이즐',
        isServiceFee: false,
    },
    [tripTransactionPlatforms.TMONEY]: {
        name: '티머니',
        isServiceFee: false,
    },
    [tripTransactionPlatforms.KAKAO]: {
        name: '카카오',
        isServiceFee: false,
    },
    [tripTransactionPlatforms.KAKAO_SERVICE]: {
        name: '카카오서비스',
        isServiceFee: true,
    },
    [tripTransactionPlatforms.KONA]: {
        name: '코나',
        isServiceFee: false,
    },
}

export function getPlatformName(platform) {
    if (!tripTransactionPlatformData[platform]) {
        return platform;
    }

    return tripTransactionPlatformData[platform].name;
}

const tripTransactionPayStatusData = {
    APPROVED: {
        id: 'APPROVED',
        name: '승인'
    },
    CANCELLED: {
        id: 'CANCELLED',
        name: '취소',
    },
}

class TripTransaction {
    constructor(
        uuid,
        platform,
        officeId,
        carNum,
        driverId,
        cardCompanyName,
        payDriverId,
        payMethod,
        payStatus,
        hipassFee,
        payerTotalAmt,
        eventDtti,
        refId,
        createdByName,
    ) {
        this.uuid = uuid;
        this.platform = platform;
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId;
        this.cardCompanyName = cardCompanyName;
        this.payDriverId = payDriverId;
        this.payMethod = payMethod;
        this.payStatus = payStatus;
        this.hipassFee = hipassFee;
        this.payerTotalAmt = payerTotalAmt;
        this.eventDtti = eventDtti;
        this.eventDttiJs = dayJsFromDtti(eventDtti);
        this.refId = refId;
        this.createdByName = createdByName;
    }

    hasEqualRefIf(anotherRefId) {
        if (typeof this.refId !== 'string' || typeof anotherRefId !== 'string') {
            return false;
        }

        return this.refId === anotherRefId;
    }

    get displayPlatform() {
        return getPlatformName(this.platform);
    }

    get displayEventDtti() {
        return this.eventDttiJs.format(dateLongFormat);
    }

    get displayPayStatus() {
        if (!tripTransactionPayStatusData[this.payStatus]) {
            return '-'
        }

        return tripTransactionPayStatusData[this.payStatus].name;
    }

    get displayHipassFee() {
        return displayCash(this.hipassFee);
    }

    get displayPayerTotalAmt() {
        return displayCash(this.payerTotalAmt);
    }

    static fromApi(v) {
        return new TripTransaction(
            v.uuid,
            v.platform,
            v.officeId,
            v.carNum,
            v.driverId,
            v.cardCompanyName,
            v.payDriverId,
            v.payMethod,
            v.payStatus,
            v.hipassFee,
            v.payerTotalAmt,
            v.eventDtti,
            v.refId,
            v.createdByName,
        );
    }
}

class TripWithCustomDto extends TripDto{
    constructor(
        stDtti,
        payStartDtti,
        edDtti,
        officeId,
        carNum,
        driverId,
        distFare,
        addFare,
        callFee,
        hipassFee,
        voucherDiscount,
        payTotal,
        payType,
        tripDist,
        emptyDist,
        createdByName,
        uuid,
        distFareOld,
        addFareOld,
        callFeeOld,
        hipassFeeOld,
        voucherDiscountOld,
        payTotalOld,
    ) {
        super(
            stDtti,
            payStartDtti,
            edDtti,
            officeId,
            carNum,
            driverId,
            distFare,
            addFare,
            callFee,
            hipassFee,
            voucherDiscount,
            payTotal,
            payType,
            tripDist,
            emptyDist,
        )
        this.createdByName = createdByName;
        this.uuid = uuid;
        this.distFareOld = distFareOld;
        this.addFareOld = addFareOld;
        this.callFeeOld = callFeeOld;
        this.hipassFeeOld = hipassFeeOld;
        this.voucherDiscountOld = voucherDiscountOld;
        this.payTotalOld = payTotalOld;
    }

    get displayDistFareOld() {
        return displayCash(this.distFareOld);
    }

    get displayCallFeeOld() {
        return displayCash(this.callFeeOld);
    }

    get displayHipassFeeOld() {
        return displayCash(this.hipassFeeOld);
    }

    get displayAddFareOld() {
        return displayCash(this.addFareOld);
    }

    get displayVoucherDiscountOld() {
        return this.voucherDiscount > 0 ? `-${displayCash(this.voucherDiscount)}` : '0Old';
    }

    get displayPayTotalOld() {
        return displayCash(this.payTotalOld);
    }

    toCreationDto() {
        return {
            stDtti: this.stDtti,
            payStartDtti: this.payStartDtti,
            edDtti: this.edDtti,
            officeId: this.officeId,
            carNum: this.carNum,
            driverId: this.driverId,
            distFare: this.distFare,
            addFare: this.addFare,
            callFee: this.callFee,
            hipassFee: this.hipassFee,
            voucherDiscount: this.voucherDiscount,
            payTotal: this.payTotal,
            payType: this.payType,
            tripDist: this.tripDist,
            emptyDist: this.emptyDist,
        }
    }

    static fromApi(v) {
        return new TripWithCustomDto(
            v.stDtti,
            v.payStartDtti,
            v.edDtti,
            v.officeId,
            v.carNum,
            v.driverId,
            v.distFare,
            v.addFare,
            v.callFee,
            v.hipassFee,
            v.voucherDiscount,
            v.payTotal,
            v.payType,
            v.tripDist,
            v.emptyDist,
            v.createdByName,
            v.uuid,
            v.distFareOld,
            v.addFareOld,
            v.callFeeOld,
            v.hipassFeeOld,
            v.voucherDiscountOld,
            v.payTotalOld,
        );
    }
}

class TripAndTransaction {
    constructor(
        trip,
        transactions,
        serviceFees,
        hasDuplicateTrans,
    ) {
        this.trip = trip;
        this.transactions = transactions;
        this.serviceFees = serviceFees;
        this.hasDuplicateTrans = hasDuplicateTrans;
    }

    static fromApi(v) {
        return new TripAndTransaction(
            TripWithCustomDto.fromApi(v.trip),
            v.transactions.map((v) => TripTransaction.fromApi(v)),
            v.serviceFees.map((v) => TripTransaction.fromApi(v)),
            v.hasDuplicateTrans,
        );
    }
}

class TripTransactionParseEvent {
    constructor(
        createdAtDtti,
        createdBy,
        createdByName,
        failCt,
        fileName,
        maxDtti,
        minDtti,
        officeId,
        platform,
        storedInDb,
        successCt,
        totalCt,
    ) {
        this.createdAtDtti = createdAtDtti;
        this.createdBy = createdBy;
        this.createdByName = createdByName;
        this.failCt = failCt;
        this.fileName = fileName;
        this.maxDtti = maxDtti;
        this.minDtti = minDtti;
        this.officeId = officeId;
        this.platform = platform;
        this.storedInDb = storedInDb;
        this.successCt = successCt;
        this.totalCt = totalCt;
    }

    get storedInDbDisplay() {
        return this.storedInDb ? '등록' : '파싱';
    }

    get platformDisplay() {
        return getPlatformName(this.platform);
    }

    get createdAtDisplay() {
        return dayJsFromDtti(this.createdAtDtti).format(dateLongFormat);
    }

    static fromApi(v) {
        return new TripTransactionParseEvent(
            v.createdAtDtti,
            v.createdBy,
            v.createdByName,
            v.failCt,
            v.fileName,
            v.maxDtti,
            v.minDtti,
            v.officeId,
            v.platform,
            v.storedInDb,
            v.successCt,
            v.totalCt,
        );
    }
}

const tachoEntity = {
    drivingDailyEntity,
    periodSummaryEntity,
    periodRecordEntity,
    drivingCloseDailyEntity,
    drivingMonthlyEntity,
    tripDetailClosingDayDataEntity,
    tripDetailDataEntity,
    tripDetailClosingDayCommuteDataEntity,
    tripDetailCommuteDataEntity,
    privateDrivingDataEntity,
    drivingSearchDto,
    driverIncome,
    drivingCloseSearchDto,
    paymentTypeEnum,
    drivingAggregateSummaryDto,
    drivingAggregateDetailDto,
    tachoVoucherDto,
    privateTachoVoucherDto,
    companyEntity,
    vehicleEntity,
    transactionEntity,
    locationHistoryEntity,
    driveInfoDto,
    cityStatDto,
    cityInternalDto,
    driverIncomeDto,
    buttonEventDto,
    acrmDataDto,
    drivingGraphSummaryDto,
    drivingGraphPrintDto,
    drivingGraphRecordDto,
    acrmEventErrorDto,
    appmeterDto,
    drivingGraphDetailDto,
    drivingGraphOnHistDto,
    jobTypeEnum,
    jobPositionTypeEnum,
    jobStateEnum,
    drivingTypeEnum,
    drivingStateEnum,
    regionTypeEnum,
    carTypeEnum,
    companyTypeEnum,
    periodTypeEnum,
    getKeyByValue,
    vehicleQueryParam,
    lastTransactionQueryParam,
    locationHistoryQueryParam,
    appmeterCarTypeEnum,
    appmeterQueryParam,
    companyQueryParam,
    employeeEntity,
    employeeQueryParam,
    baseUrl,
    tachodUrl,
    tachoDataDto,
    commuteManagementEntity,
    privateButtonEventDto,
    TripDto,
    TripWithCustomDto,
    RouteRangeDto,
    RouteDetailDto,
    CarRouteDetailsAggDto,
    AcrmEventErrorDto,
    AcrmEventErrorDetailDto,
    TripTransaction,
    tripTransactionPlatforms,
    tripTransactionPlatformData,
    tripTransactionPayStatusData,
    getPlatformName,
    TripAndTransaction,
    TripTransactionParseEvent,
}

export default tachoEntity
